export enum EKwikUIStarRatingSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIStarRatingSize = [
  EKwikUIStarRatingSize.S,
  EKwikUIStarRatingSize.M,
  EKwikUIStarRatingSize.L
] as const;

export type TKwikUIStarRatingSize = (typeof VKwikUIStarRatingSize)[number];
